var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnDownvoted = function SvgIcnDownvoted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10h2.333V3H13.5m-2.333 0h-5.25c-.484 0-.899.292-1.074.712L3.082 7.824A1.152 1.152 0 0 0 3 8.25v1.167a1.167 1.167 0 0 0 1.167 1.166h3.68l-.554 2.666a.868.868 0 0 0 .24.8l.618.618 3.838-3.845a1.14 1.14 0 0 0 .344-.822V4.167c0-.648-.525-1.167-1.166-1.167Z",
    fill: "#292525"
  })));
};
export default SvgIcnDownvoted;